Date.isLeapYear = function (year) {
    return (((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0));
};

Date.getDaysInMonth = function (year, month) {
    return [31, (Date.isLeapYear(year) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
};

Date.prototype.isLeapYear = function () {
    return Date.isLeapYear(this.getFullYear());
};

Date.prototype.getDaysInMonth = function () {
    return Date.getDaysInMonth(this.getFullYear(), this.getMonth());
};

Date.prototype.addMonths = function (value) {
    let n = this.getDate();
    this.setDate(1);
    this.setMonth(this.getMonth() + value);
    this.setDate(Math.min(n, this.getDaysInMonth()));
    return this;
};


// y-m-d H:i:s
const formatDate = (date, format = 'y-m-d') => {
    if (!date) {
        return '';
    }

    let dt;

    if (date instanceof Date) {
        // date is date class
        dt = date;
    } else {
        // date is string
        // separate date and time
        let [d, t] = date.split(" ");

        let parts = d.split("-");
        if (parts.length < 3) {
            console.log("formatDate: wrong date", date, parts);
            return '';
        }
        if (parts[0].length == 4) { // year comes first
            dt = new Date(date);
        } else {
            dt = new Date(`${parts[2]}-${parts[1]}-${parts[0]}` + (t ? ` ${t}` : ''));
        }
    }

    let dateStr = '';
    for (let i = 0; i < format.length; i++) {
        if (format[i] === 'y') {
            dateStr += dt.getFullYear();
        } else if (format[i] === 'm') {
            dateStr += pad0(dt.getMonth() + 1);
        } else if (format[i] === 'd') {
            dateStr += pad0(dt.getDate());
        } else if (format[i] === 'H') {
            dateStr += pad0(dt.getHours());
        } else if (format[i] === 'i') {
            dateStr += pad0(dt.getMinutes());
        } else if (format[i] === 's') {
            dateStr += pad0(dt.getSeconds());
        } else {
            dateStr += format[i];
        }
    }
    return dateStr;
}

const pad0 = x => x.toString().padStart(2, "0");

const sort = (array, key, descending) => {
    if (descending) {
        return array.sort((a, b) => (a[key] < b[key] ? 1 : -1));
    }

    return array.sort((a, b) => (a[key] > b[key] ? 1 : -1));
}

const setFocusTo = (element_id, delay = 280) => {
    if (element_id) {
        setTimeout(function () {
            let element = document.getElementById(element_id);
            if (element) element.focus();
        }, delay);
    }
}

const scrollTo = (element_id, offset = 0) => {
    if (element_id === 'top') {
        window.scrollTo({top: 0, behavior: 'smooth'});
    } else {
        let scrollDiv = document.getElementById(element_id).offsetTop + offset;
        window.scrollTo({ top: scrollDiv, behavior: 'smooth'});
    }
}

const upCaseStr = str => {
    if (!str) {
        return "";
    }
    let arr = [['Ά', 'Α'], ['Έ', 'Ε'], ['Ή', 'Η'], ['Ί', 'Ι'], ['Ϊ', 'Ι'], ['Ό', 'Ο'], ['Ύ', 'Υ'], ['Ϋ', 'Υ'], ['Ώ', 'Ω']];
    str = str.toUpperCase();
    arr.map(chars => {
        str = str.split(chars[0]).join(chars[1]);
    });
    return str;
}

export {
    pad0,
    formatDate,
    sort,
    setFocusTo,
    scrollTo,
    upCaseStr,
}